import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Card, Checkbox, Table, Typography } from "antd";
import { useEffect, useState } from 'react';
import { formatDisplayDate } from "../../utils/commonUtil";
import { Link } from "react-router-dom";
const SubProjectResultsDataTable = ({ dataSource, loading, pagination, onChange, }) => {
    const [tableData, setTableData] = useState();
    const columns = [
        {
            title: 'Entity Company Name',
            dataIndex: 'entityName',
            key: 'entityName',
            //ellipsis: true,
        },
        {
            title: 'Sub Project No',
            dataIndex: 'subProjectNo',
            key: 'subProjectNo',
            render: (text, record) => (_jsx(Link, { to: `/vendor/sub-project-detail/${record === null || record === void 0 ? void 0 : record.subProjEncodedId}`, children: text })),
        },
        {
            title: 'Sub Project Status',
            dataIndex: 'subProjectStatus',
            key: 'subProjectStatus',
        },
        {
            title: 'Product Name',
            dataIndex: 'productName',
            key: 'productName',
        },
        {
            title: 'Brand/OEM',
            dataIndex: 'brandName',
            key: 'brandName',
        },
        {
            title: 'Certificate Name',
            dataIndex: 'certificateName',
            key: 'certificateName',
        },
        {
            title: 'Product Model',
            dataIndex: 'productModel',
            key: 'productModel',
        },
        {
            title: 'Country/Territory',
            dataIndex: 'country',
            key: 'country',
        },
        {
            title: 'Service Type',
            dataIndex: 'serviceType',
            key: 'serviceType',
        },
        {
            title: 'Technology',
            dataIndex: 'technology',
            key: 'technology',
        },
        {
            title: 'Product Sub Segment',
            dataIndex: 'productSubSegment',
            key: 'productSubSegment',
        },
        {
            title: 'Risk Status',
            dataIndex: 'riskStatus',
            key: 'riskStatus',
        },
        {
            title: 'Sub Project Type',
            dataIndex: 'subProjectType',
            key: 'subProjectType',
        },
        {
            title: 'BV Sub Project Assigned Start Date',
            dataIndex: 'spAssignedDate',
            key: 'spAssignedDate',
        },
        {
            title: 'BV Planned Completion Date',
            dataIndex: 'spPlnCompletionDate',
            key: 'spPlnCompletionDate',
        },
        {
            title: 'Actual Completion Date',
            dataIndex: 'actualCompletionDate',
            key: 'actualCompletionDate',
        },
        {
            title: 'Vendor Start Date',
            dataIndex: 'vendorStartDate',
            key: 'vendorStartDate',
        },
        {
            title: 'Vendor Planned Completion Date',
            dataIndex: 'vPlnCompletionDate',
            key: 'vPlnCompletionDate',
        },
        {
            title: 'BV Location',
            dataIndex: 'bvLocation',
            key: 'bvLocation',
        },
    ];
    const columnsForCheckbox = ['technology', 'productSubSegment', 'riskStatus', 'subProjectType',
        'spPlnCompletionDate', 'actualCompletionDate', 'vendorStartDate',
        'vPlnCompletionDate', 'bvLocation'];
    const [checkedList, setCheckedList] = useState();
    const options = columns
        .filter(({ key }) => columnsForCheckbox.includes(key))
        .map(({ key, title }) => ({
        label: title,
        value: key,
    }));
    const newColumns = columns.map((item) => (Object.assign(Object.assign({}, item), { hidden: !(checkedList === null || checkedList === void 0 ? void 0 : checkedList.includes(item.key)) && columnsForCheckbox.includes(item.key) })));
    // Filter columns to only include those that are not hidden
    const visibleColumns = newColumns.filter((column) => !column.hidden || !columnsForCheckbox.includes(column.key));
    useEffect(() => {
        const tableData_ = dataSource === null || dataSource === void 0 ? void 0 : dataSource.map((item, index) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w;
            const subProjEncodedId = btoa(((_a = item === null || item === void 0 ? void 0 : item.strWorkOrderId) === null || _a === void 0 ? void 0 : _a.toString()) || '');
            return {
                key: index,
                entityName: (_c = (_b = item === null || item === void 0 ? void 0 : item.objClientMaster) === null || _b === void 0 ? void 0 : _b.objLuCompany) === null || _c === void 0 ? void 0 : _c.strLongDesc,
                subProjectNo: item === null || item === void 0 ? void 0 : item.strWorkOrderId,
                subProjectStatus: (_d = item === null || item === void 0 ? void 0 : item.objLuWorkOrderStatus) === null || _d === void 0 ? void 0 : _d.strLongDesc,
                productName: (_e = item === null || item === void 0 ? void 0 : item.objEEMaster) === null || _e === void 0 ? void 0 : _e.strProductNameEN,
                brandName: (_g = (_f = item === null || item === void 0 ? void 0 : item.objEEMaster) === null || _f === void 0 ? void 0 : _f.objBrandName) === null || _g === void 0 ? void 0 : _g.strLongDesc,
                certificateName: (_h = item === null || item === void 0 ? void 0 : item.objTblService) === null || _h === void 0 ? void 0 : _h.strServiceName,
                productModel: (_j = item === null || item === void 0 ? void 0 : item.objEEMaster) === null || _j === void 0 ? void 0 : _j.strPrimaryModel,
                country: (_l = (_k = item === null || item === void 0 ? void 0 : item.objTblService) === null || _k === void 0 ? void 0 : _k.objLuCountry) === null || _l === void 0 ? void 0 : _l.strLongDesc,
                serviceType: (_o = (_m = item === null || item === void 0 ? void 0 : item.objTblService) === null || _m === void 0 ? void 0 : _m.objLuServiceCode) === null || _o === void 0 ? void 0 : _o.strLongDesc,
                technology: (_q = (_p = item === null || item === void 0 ? void 0 : item.objEEMaster) === null || _p === void 0 ? void 0 : _p.objLuTechnologyType) === null || _q === void 0 ? void 0 : _q.strLongDesc,
                productSubSegment: (_s = (_r = item === null || item === void 0 ? void 0 : item.objEEMaster) === null || _r === void 0 ? void 0 : _r.objLuProductType) === null || _s === void 0 ? void 0 : _s.strLongDesc,
                riskStatus: (item === null || item === void 0 ? void 0 : item.intRiskStatus) === 1 ? 'Project on Schedule' : (item === null || item === void 0 ? void 0 : item.intRiskStatus) === 2 ? 'Project on Risk' : '',
                subProjectType: (_u = (_t = item === null || item === void 0 ? void 0 : item.objTblService) === null || _t === void 0 ? void 0 : _t.objLuRequestType) === null || _u === void 0 ? void 0 : _u.strLongDesc,
                spAssignedDate: formatDisplayDate(item === null || item === void 0 ? void 0 : item.dtStartDate),
                spPlnCompletionDate: formatDisplayDate(item === null || item === void 0 ? void 0 : item.dtEstimatedComplDate),
                actualCompletionDate: formatDisplayDate(item === null || item === void 0 ? void 0 : item.dtCompletionDate),
                vendorStartDate: formatDisplayDate(item === null || item === void 0 ? void 0 : item.dtVendorAssignedDate),
                vPlnCompletionDate: formatDisplayDate(item === null || item === void 0 ? void 0 : item.dtVendorPlannedCompDate),
                bvLocation: (_w = (_v = item === null || item === void 0 ? void 0 : item.objEEMaster) === null || _v === void 0 ? void 0 : _v.objBusinessUnit) === null || _w === void 0 ? void 0 : _w.strBusinessUnitName,
                subProjEncodedId: subProjEncodedId,
            };
        });
        setTableData(tableData_);
    }, [dataSource]);
    return (_jsxs(Card, { style: { borderRadius: '0px' }, title: _jsxs(Typography.Text, { children: ["Sub Project Search Result (Total Records: ", pagination.total, " )"] }), children: [_jsx(Table, { columns: visibleColumns, dataSource: tableData, size: 'small', style: { marginBottom: 24 }, scroll: { x: 'min-content' }, loading: loading, pagination: pagination, onChange: onChange }), _jsx(Checkbox.Group, { value: checkedList, options: options, onChange: (value) => {
                    setCheckedList(value);
                } })] }));
};
export default SubProjectResultsDataTable;
